import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useLanguage } from "../languageContext";
import translations from "../translation.json";
import Select from "react-select";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
import Loader from "../loader";
import Dropzone from "react-dropzone";
import { ApiUrl } from "../ApiUrl";
import Papa from "papaparse";

const CHUNK_SIZE = 50;

const BulkUpload = ({
  isDarkMode,
  eventId,
  listIds,
  configIds,
  getListIds,
  fetchData,
  links
}) => {
  const token = localStorage.getItem("token");
  const { language } = useLanguage();
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [successfulRows, setSuccessfulRows] = useState(0);
  const [failedRows, setFailedRows] = useState(0);
  const [showStat, setShowStat] = useState(false);

  var button = document.getElementById("bulkUploadClose");
  var currentUrl = window.location.href;

  // console.log(currentUrl.includes("events"));

  const initialData = {
    private_event_id: eventId || "",
    list_id: "",
    list_name: "",
    // config_id: "",
    data: "",
  };
  const validationSchema = Yup.object().shape({
     data: Yup.mixed().required("Please upload a file."),
  });

  const handleSubmit = async (values, { resetForm }, error) => {
    try {
      // setLoading(true);
      // setUploading(true);
      // const formdata = new FormData();
      // Object.keys(values).forEach((key) => {
      //   formdata.append(key, values[key]);
      // });
      // const res = await fetch(ApiUrl + "/api/user/import-csv", {
      //   method: "POST",
      //   headers: {
      //     // "Content-Type": "application/json",
      //     Authorization: `Bearer ${token}`,
      //   },
      //   body: formdata,
      // });
      // const data = await res.json();
      // if (data.status === "success") {
      //   resetForm();
      //   fetchData();
      //   button.click();
      //   toast.success(data.msg);
      // } else {
      //   toast.error(translations.alertMessages.wentWrong[language]);
      // }
      // setLoading(false);
      setUploading(true);
      await parseCSVAndUpload(values.data, values);
      // resetForm();
      toast.success(translations.clients.fileUploadSuccess[language]);
      setShowStat(true);
      // fetchData();
      // button.click();
    } catch (error) {
      // setLoading(false);
      // setUploading(false);
      // setUploadProgress(0);
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
      setLoading(false);
      // setUploading(false);
      // setUploadProgress(0);
    }
  };

  // const parseCSVAndUpload = async (file, values) => {
  //   return new Promise((resolve, reject) => {
  //     Papa.parse(file, {
  //       header: true,
  //       skipEmptyLines: true,
  //       complete: async (results) => {
  //         const rows = results.data;
  //         setTotalRows(rows.length); // update total row count
  //         const statusAnnotatedRows = [];
  //         const chunks = [];

  //         for (let i = 0; i < rows.length; i += CHUNK_SIZE) {
  //           chunks.push(rows.slice(i, i + CHUNK_SIZE));
  //         }

  //         for (let i = 0; i < chunks.length; i++) {
  //           const chunk = chunks[i];
  //           const chunkWithStatus = [];
  //           const newData = { ...values, data: chunk };
  //           const formdata = new FormData();
  //           Object.keys(newData).forEach((key) => {
  //             formdata.append(key, newData[key]);
  //           });

  //           try {
  //             const res = await fetch(ApiUrl + "/api/user/import-csv", {
  //               method: "POST",
  //               headers: {
  //                 "Content-Type": "application/json",
  //                 Authorization: `Bearer ${token}`,
  //               },
  //               body: JSON.stringify(newData),
  //             });
  //             const result = await res.json()
  //             console.log("result>>>>>>.",res , result,chunk)
  //             if (!res.ok) {
  //               chunk.forEach((row) => {
  //                 chunkWithStatus.push({
  //                   ...row,
  //                   status: translations.commonWords.failed[language],
  //                 });
  //               });
  //               setFailedRows((prev) => prev + chunk.length); // update failed rows count
  //               const error = await res.text();
  //               // throw new Error(`Chunk ${i + 1} failed: ${error}`);
  //             } 
  //             // else {
  //             //   chunk.forEach((row) => {
  //             //     chunkWithStatus.push({
  //             //       ...row,
  //             //       status: translations.commonWords.success[language],
  //             //     });
  //             //   });
  //             //   setSuccessfulRows((prev) => prev + chunk.length); // update success rows count
  //             // }
  //             // statusAnnotatedRows.push(...chunkWithStatus);
  //             // const percent = Math.round(((i + 1) / chunks.length) * 100);
  //             // setUploadProgress(percent);
  //             else {
  //               if (result.prospectiveData2) {
  //                 const failedData = Object.values(result.prospectiveData2);
              
  //                 chunk.forEach((row) => {
  //                   const isMatch = failedData.some((failRow) => {
  //                     // Compare only meaningful fields (e.g., "Courriel" and "NIV")
  //                     return (
  //                       row["Courriel"] === failRow["Courriel"] &&
  //                       row["NIV"] === failRow["NIV"]
  //                     );
  //                   });
              
  //                   chunkWithStatus.push({
  //                     ...row,
  //                     status: isMatch
  //                       ? translations.commonWords.failed[language]
  //                       : translations.commonWords.success[language],
  //                   });
              
  //                   if (isMatch) {
  //                     setFailedRows((prev) => prev + 1);
  //                   } else {
  //                     setSuccessfulRows((prev) => prev + 1);
  //                   }
  //                 });
  //               } else {
  //                 chunk.forEach((row) => {
  //                   chunkWithStatus.push({
  //                     ...row,
  //                     status: translations.commonWords.success[language],
  //                   });
  //                 });
  //                 setSuccessfulRows((prev) => prev + chunk.length);
  //               }
  //             }
  //           } catch (err) {
  //             // chunk.forEach((row) => {
  //             //   statusAnnotatedRows.push({
  //             //     ...row,
  //             //     status: translations.commonWords.failed[language],
  //             //   });
  //             // });
  //             // reject(err);
  //             // return;
  //             const chunkWithStatus = chunk.map((row) => ({
  //               ...row,
  //               status: translations.commonWords.failed[language],
  //             }));
  //             setFailedRows((prev) => prev + chunk.length);
  //             statusAnnotatedRows.push(...chunkWithStatus);
  //             console.error(`Chunk ${i + 1} error:`, err.message);
  //           }
  //         }
  //         // Trigger CSV download after all chunks
  //         const csv = Papa.unparse(statusAnnotatedRows);
  //         const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  //         const url = URL.createObjectURL(blob);
  //         const link = document.createElement("a");
  //         link.href = url;
  //         link.setAttribute(
  //           "download",
  //           translations.clients.uploadedFileReport[language] + ".csv"
  //         );
  //         document.body.appendChild(link);
  //         link.click();
  //         document.body.removeChild(link);
  //         resolve();
  //       },
  //       error: (err) => {
  //         reject(err);
  //       },
  //     });
  //   });
  // };
  const parseCSVAndUpload = async (file, values) => {
    return new Promise((resolve, reject) => {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: async (results) => {
          const rows = results.data;
          setTotalRows(rows.length);
          const statusAnnotatedRows = [];
          const chunks = [];
  
          for (let i = 0; i < rows.length; i += CHUNK_SIZE) {
            chunks.push(rows.slice(i, i + CHUNK_SIZE));
          }
  
          for (let i = 0; i < chunks.length; i++) {
            const chunk = chunks[i];
            const chunkWithStatus = [];
            const newData = { ...values, data: chunk };
  
            try {
              const res = await fetch(ApiUrl + "/api/user/import-csv", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(newData),
              });
  
              const result = await res.json();
              // console.log("result >>>>>>", res, result, chunk);

              if (!res.ok) {
                chunk.forEach((row) => {
                  chunkWithStatus.push({
                    ...row,
                    // status: translations.commonWords.failed[language],
                    status: "Failed",

                  });
                });
                setFailedRows((prev) => prev + chunk.length);
              } else {
                if (
                  result.prospectiveData2 &&
                  typeof result.prospectiveData2 === "object" &&
                  !Array.isArray(result.prospectiveData2)
                ) {
                  // console.log("result.prospectiveData2",result.prospectiveData2)
                  // const failedData = Object.values(result.prospectiveData2);
                  //  console.log("failedDatafailedData",failedData,chunk)
                  // chunk.forEach((row) => {
                  //   const isMatch = failedData.some((failRow) => {
                  //     return (
                  //       row[translations.quickCreationModal.phoneNumber[language]] === failRow[translations.quickCreationModal.phoneNumber[language]] &&
                  //       row[translations.commonFields.email[language]] === failRow[translations.commonFields.email[language]]
                  //     );
                  //   });
                  //   chunkWithStatus.push({
                  //     ...row,
                  //     status: isMatch
                  //       ? translations.commonWords.failed[language]
                  //       : translations.commonWords.success[language],
                  //   });
  
                  //   if (isMatch) {
                  //     setFailedRows((prev) => prev + 1);
                  //   } else {
                  //     setSuccessfulRows((prev) => prev + 1);
                  //   }
                  // });
                  const firstKey = Object.keys(result.prospectiveData2)[0];
                  const firstRow = result.prospectiveData2[firstKey];

                  // ✅ Detect language
                  let check_language = "en"; // default fallback
                  // console.log("firstRow.hasOwnProperty",firstRow.hasOwnProperty("NIV"))
                  if (firstRow.hasOwnProperty("NIV")) {
                    check_language = "fr";
                  } else if (firstRow.hasOwnProperty("VIN")) {
                    check_language = "en";
                  }

                  const isEmpty = (val) => {
                    return val === null || val === undefined || val === "" ||
                      (typeof val === 'string' && val.trim() === "");
                  };

                  const areValuesEqual = (val1, val2) => {
                    // console.log(";alskdfl;askdf", val1, val2)
                    // If both are empty, consider them equal
                    if (isEmpty(val1) && isEmpty(val2)) return true;
                    // Otherwise, direct comparison
                    return val1 === val2;
                  };
                  const failedData = Object.values(result.prospectiveData2);

                  const phoneKey = translations.quickCreationModal.phoneNumber[check_language];
                  const emailKey = translations.commonFields.email[check_language];
                  const vinKey = translations.createProspective.VIN[check_language];

                  chunk.forEach((row) => {
                    const isMatch = failedData.some((failRow) => {
                      // Match by VIN (most reliable)
                      if (row[vinKey] && failRow[vinKey] && row[vinKey] === failRow[vinKey]) {
                        // console.log("asdgasdfasdf", row[vinKey], failRow[vinKey])
                        return true;
                      }

                      // Fallback: Match by phone + email
                      const phoneMatch = areValuesEqual(row[phoneKey], failRow[phoneKey]);
                      const emailMatch = areValuesEqual(row[emailKey], failRow[emailKey]);

                      return phoneMatch && emailMatch;
                    });

                    chunkWithStatus.push({
                      ...row,
                      status: isMatch
                       ? "Failed"
                        : "Success",
                        // ? translations.commonWords.failed[language]
                        // : translations.commonWords.success[language],
                    });

                    if (isMatch) {
                      setFailedRows((prev) => prev + 1);
                    } else {
                      setSuccessfulRows((prev) => prev + 1);
                    }
                  });
                } else {
                  chunk.forEach((row) => {
                    chunkWithStatus.push({
                      ...row,
                      // status: translations.commonWords.success[language],
                      status: "Success",

                    });
                  });
                  setSuccessfulRows((prev) => prev + chunk.length);
                }
              }
  
              // Push the annotated rows from this chunk to the main array
              statusAnnotatedRows.push(...chunkWithStatus);
              const percent = Math.round(((i + 1) / chunks.length) * 100);
              setUploadProgress(percent);
            } catch (err) {
              const chunkWithStatus = chunk.map((row) => ({
                ...row,
                // status: translations.commonWords.failed[language],
                status: "Failed",

              }));
              setFailedRows((prev) => prev + chunk.length);
              statusAnnotatedRows.push(...chunkWithStatus);
              console.error(`Chunk ${i + 1} error:`, err.message);
            }
          }
  
          // ✅ Final CSV download
          if (statusAnnotatedRows.length > 0) {
            const csv = Papa.unparse(statusAnnotatedRows);
            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              translations.clients.uploadedFileReport[language] + ".csv"
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            fetchData(true);
            // button.click();
          } else {
            console.warn("No rows processed for download.");
          }
  
          resolve();
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
  return (
    <div id="bulkUploadModal" className="modal fade" tabindex="-1">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <Formik
            initialValues={initialData}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            id="creationsuccess"
          >
            {({ errors, values, setValues, resetForm, isSubmitting }) => (
              <Form>
                <div
                  className="modal-header"
                  style={{
                    borderBottom: isDarkMode
                      ? "1px solid #495057"
                      : "1px solid #dee2e6",
                  }}
                >
                  <h3 style={{ color: "#000000" }}>
                    {translations.clients.uploadFile[language]}
                  </h3>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    onClick={() => button.click()}
                    style={{
                      filter: isDarkMode ? "invert(1)" : "none", // Invert the color in dark mode
                      color: isDarkMode
                        ? "#ffffff"
                        : "rgb(255, 255, 255) !important",
                    }}
                    id="closeModalBtn"
                  ></button>
                </div>
                <div
                  className="modal-body"
                  style={{ height: "350px", overflowY: "auto" }}
                >
                  <div className="row">
                    <div className="mb-3 col-12">
                      <label className="form-label">
                        {translations.createProspective.listIds[language]}
                      </label>
                      <Field
                        name="list_id"
                        render={({ field, form }) => (
                          <Select
                            className="selectpicker"
                            aria-labelledby="dealership-name-quick"
                            // isClearable
                            options={listIds}
                            placeholder={
                              translations["dropdown"].select[language]
                            }
                            isSearchable
                            value={
                              (listIds &&
                                listIds.length > 0 &&
                                listIds.find(
                                  (option) => option?.value === field?.value
                                )) || {
                                value: "",
                                label:
                                  translations["dropdown"].select[language],
                              }
                            }
                            onFocus={() => {
                              if (listIds && listIds.length === 0) {
                                getListIds();
                              }
                            }}
                            onChange={(selectedOption) =>
                              setValues({
                                ...values,
                                list_id: selectedOption.value,
                                list_name: selectedOption.label,
                              })
                            }
                            maxMenuHeight={"120px"}
                            styles={{
                              input: (provided) => ({
                                ...provided,
                                color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                              }),
                              control: (provided, state) => ({
                                ...provided,
                                backgroundColor: isDarkMode
                                  ? "transparent"
                                  : "white",
                                border: state.isFocused
                                  ? "1px solid #80bdff"
                                  : isDarkMode
                                  ? "1px solid #495057"
                                  : "1px solid #dee2e6", // Adjust the border color for focus
                                boxShadow: state.isFocused
                                  ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                  : "none", // Bootstrap's box shadow for focus
                                borderRadius: ".45rem",
                              }),
                              valueContainer: (provided) => ({
                                ...provided,
                                padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                              }),
                              indicatorSeparator: (provided) => ({
                                ...provided,
                                display: "none", // Hide the indicator separator
                              }),
                              dropdownIndicator: (provided) => ({
                                ...provided,
                                padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                color: isDarkMode ? "#ffffff" : "#868686",
                                display: "block",
                              }),
                              menu: (provided) => ({
                                ...provided,
                                color: isDarkMode ? "#ffffff" : "black",
                                backgroundColor: isDarkMode
                                  ? "#1f2023"
                                  : "white",
                                margin: "0", // Remove default margin
                              }),
                              placeholder: (provided) => ({
                                ...provided,
                                color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                                // Additional styles for placeholder
                              }),
                              singleValue: (provided) => ({
                                ...provided,
                                color: isDarkMode ? "#ffffff" : "black",
                              }),
                              option: (provided, state) => ({
                                ...provided,
                                color: isDarkMode ? "#ffffff" : "black",
                                backgroundColor: state.isHovered
                                  ? "#80bdff"
                                  : isDarkMode
                                  ? "#1f2023"
                                  : "white",
                                ":hover": {
                                  backgroundColor: isDarkMode
                                    ? "#34DBB4"
                                    : "#34DBB4",
                                },
                              }),
                            }}
                          />
                        )}
                      />
                      <ErrorMessage
                        name="list_id"
                        component="div"
                        className="error text-danger"
                      />
                    </div>
                    <>
                      {/* <div className="mb-3 col-12">
                      <label className="form-label">
                        {translations.createProspective.configId[language]}
                      </label>
                      <Field
                        name="config_id"
                        render={({ field, form }) => (
                          <Select
                            className="selectpicker"
                            aria-labelledby="dealership-name-quick"
                            // isClearable
                            options={configIds}
                            placeholder={
                              translations["dropdown"].select[language]
                            }
                            isSearchable
                            value={
                              (configIds &&
                                configIds.length > 0 &&
                                configIds.find(
                                  (option) => option.value === field.value
                                )) || {
                                value: "",
                                label:
                                  translations["dropdown"].select[language],
                              }
                            }
                            onChange={(selectedOption) =>
                              form.setFieldValue(
                                field.name,
                                selectedOption.value
                              )
                            }
                            maxMenuHeight={"120px"}
                            styles={{
                              input: (provided) => ({
                                ...provided,
                                color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                              }),
                              control: (provided, state) => ({
                                ...provided,
                                backgroundColor: isDarkMode
                                  ? "transparent"
                                  : "white",
                                border: state.isFocused
                                  ? "1px solid #80bdff"
                                  : isDarkMode
                                  ? "1px solid #495057"
                                  : "1px solid #dee2e6", // Adjust the border color for focus
                                boxShadow: state.isFocused
                                  ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                  : "none", // Bootstrap's box shadow for focus
                                borderRadius: ".45rem",
                              }),
                              valueContainer: (provided) => ({
                                ...provided,
                                padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                              }),
                              indicatorSeparator: (provided) => ({
                                ...provided,
                                display: "none", // Hide the indicator separator
                              }),
                              dropdownIndicator: (provided) => ({
                                ...provided,
                                padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                color: isDarkMode ? "#ffffff" : "#868686",
                                display: "block",
                              }),
                              menu: (provided) => ({
                                ...provided,
                                color: isDarkMode ? "#ffffff" : "black",
                                backgroundColor: isDarkMode
                                  ? "#1f2023"
                                  : "white",
                                margin: "0", // Remove default margin
                              }),
                              placeholder: (provided) => ({
                                ...provided,
                                color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                                // Additional styles for placeholder
                              }),
                              singleValue: (provided) => ({
                                ...provided,
                                color: isDarkMode ? "#ffffff" : "black",
                              }),
                              option: (provided, state) => ({
                                ...provided,
                                color: isDarkMode ? "#ffffff" : "black",
                                backgroundColor: state.isHovered
                                  ? "#80bdff"
                                  : isDarkMode
                                  ? "#1f2023"
                                  : "white",
                                ":hover": {
                                  backgroundColor: isDarkMode
                                    ? "#34DBB4"
                                    : "#34DBB4",
                                },
                              }),
                            }}
                          />
                        )}
                      />
                      <ErrorMessage
                        name="config_id"
                        component="div"
                        className="error text-danger"
                      />
                    </div> */}
                    </>

                    <div className="col-12" style={{ position: "relative" }}>
                      <Dropzone
                        // disabled={!editable}
                        style={{
                          backgroundColor: isDarkMode
                            ? "#ced4da66"
                            : "#ced4da66",
                        }}
                        multiple={false}
                        accept=".csv, .xlsx"
                        onDrop={(acceptedFiles) => {
                          // console.log(acceptedFiles)
                          if (acceptedFiles.length > 0) {
                            setValues({
                              ...values,
                              data: acceptedFiles[0],
                            });
                          }
                        }}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <div className="client-form-row w-100">
                            <div className="w-100">
                              <label
                                htmlFor="data"
                                className="pb-3"
                                style={{
                                  color: isDarkMode ? "#33dbb4" : "",
                                  fontSize: "20px",
                                  fontWeight: 600,
                                }} /*className="form-label"*/
                              >
                                {translations.clients.bulkUploadTitle[language]}
                              </label>

                              <div
                                {...getRootProps()}
                                role="presentation"
                                tabIndex="0"
                                style={{
                                  background: isDarkMode
                                    ? "#ced4da77"
                                    : "rgb(231, 236, 239)",
                                  // backgroundImage: `url(${URL.createObjectURL(values.logo)})`,
                                  // backgroundSize: "cover",
                                  // backgroundPosition: "center",
                                  padding: "25px 0px",
                                  borderRadius: "0.375rem",
                                  height: "180px",
                                  display: "flex",
                                  alignContent: "center",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                              >
                                <input
                                  {...getInputProps()}
                                  type="file"
                                  accept=".csv, .xlsx"
                                  name="data"
                                />
                                <div className="client-file-input">
                                  <p
                                    style={{
                                      textAlign: "center",
                                      fontSize: "15px",
                                      fontWeight: 700,
                                      marginBottom: "30px",
                                      marginTop: "20px",
                                    }}
                                  >
                                    {
                                      translations.clients.bulkUploadSubTitle[
                                        language
                                      ]
                                    }
                                  </p>
                                  <div className="pb-5">
                                    <i
                                      className="bi bi-file-earmark-arrow-up-fill"
                                      style={{
                                        border: "10px dashed #babec1",
                                        padding: "15px 100px",
                                        color: "#babec1",
                                        borderRadius: "0.375rem",
                                        fontSize: "40pt",
                                        marginTop: "10px",
                                      }}
                                    ></i>
                                  </div>
                                </div>
                              </div>

                              {values.data && (
                                <div>
                                  <div className="d-flex gap-3 align-items-center ">
                                    <div
                                      className="d-flex gap-1 py-3 align-items-center"
                                      style={{ position: "relative" }}
                                    >
                                      <i
                                        className="bi bi-x-circle"
                                        onClick={() =>
                                          setValues({ ...values, data: "" })
                                        }
                                        style={{
                                          position: "absolute",
                                          top: "16px",
                                          right: "4px",
                                          color: "red",
                                          cursor: "pointer",
                                          fontSize: "14px",
                                        }}
                                      ></i>
                                      <div
                                        className="d-flex align-items-center justify-content-center"
                                        style={{
                                          width: "65px",
                                          height: "60px",
                                        }}
                                      >
                                        <i
                                          className="bi bi-file-earmark-check"
                                          style={{ fontSize: "30px" }}
                                        ></i>
                                      </div>
                                         <span className="ms-2">{values.data.name}</span>
                                    </div>
                                  </div>
                                </div>
                              )}
                              <ErrorMessage
                                name="data"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                        )}
                      </Dropzone>
                      {uploading && (
                        <div
                          className="w-100 h-100 d-flex align-items-center justify-content-center gap-3"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            background: "rgba(255, 255, 255, 0.2)",
                            backdropFilter: "blur(3px)",
                            borderRadius: "0.75rem",
                            zIndex: 10,
                          }}
                        >
                          <div
                            style={{
                              width: "100px",
                              height: "100px",
                              position: "relative",
                            }}
                          >
                            <svg
                              width="100"
                              height="100"
                              viewBox="0 0 100 100"
                              style={{ transform: "rotate(-90deg)" }}
                            >
                              <circle
                                cx="50"
                                cy="50"
                                r="45"
                                stroke="#eee"
                                strokeWidth="10"
                                fill="none"
                              />
                              <circle
                                cx="50"
                                cy="50"
                                r="45"
                                stroke="#34DBB4"
                                strokeWidth="10"
                                fill="none"
                                strokeDasharray={2 * Math.PI * 45}
                                strokeDashoffset={
                                  2 * Math.PI * 45 * (1 - uploadProgress / 100)
                                }
                                strokeLinecap="round"
                              />
                            </svg>
                            <div
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                fontWeight: "bold",
                                fontSize: "22px",
                                color: "#34DBB4",
                              }}
                            >
                              <p>{uploadProgress.toFixed(0)}%</p>
                            </div>
                          </div>
                          {showStat && (
                            <div
                              className="d-flex flex-column"
                              style={{
                                fontWeight: "bold",
                                fontSize: "20px",
                              }}
                            >
                              {totalRows > 0 && (
                                <p>
                                  {
                                    translations.commonWords.totalRecords[
                                      language
                                    ]
                                  }
                                  {": "}
                                  {totalRows}
                                </p>
                              )}

                              {successfulRows > 0 && (
                                <p style={{ color: "#34DBB4" }}>
                                  {translations.commonWords.success[language]}
                                  {": "}
                                  {successfulRows}
                                </p>
                              )}
                              {failedRows > 0 && (
                                <p style={{ color: "red" }}>
                                  {translations.commonWords.failed[language]}
                                  {": "}
                                  {failedRows}
                                </p>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                
                <div
                  className="modal-footer"
                  id="modalfooter"
                  style={{
                    borderTop: isDarkMode
                      ? "1px solid #495057"
                      : "1px solid #dee2e6",
                      justifyContent:'space-between'
                  }}
                >
                  {
                  (links.csv_template_en || links.csv_template_fr) &&
                    <div className="d-flex gap-3  px-2" >
                      {
                        links.csv_template_en &&
                         <span
                    style={{
                      cursor: "pointer",
                       color: "#347fefff", // Bootstrap primary color
                      textDecoration: "underline",
                      fontWeight: 500,
                    }}
                    onClick={() => {
                      const link = document.createElement("a");
                      link.href = links.csv_template_en;
                      link.download = "Nexus_Template_EN.csv";
                      link.click();
                    }}
                  >
                    {/* Download English template */}
                    {translations.createProspective.Download_English_template[language]}
                  </span>
                      }
                 
                   {
                    links.csv_template_fr &&
                    <span
                    style={{
                      cursor: "pointer",
                      color: "#347fefff", // Bootstrap primary color
                      textDecoration: "underline",
                      fontWeight: 500,
                    }}
                    onClick={() => {
                      const link = document.createElement("a");
                      link.href = links.csv_template_fr;
                      link.download = "Nexus_Template_FR.csv";
                      link.click();
                    }}
                  >
                    {/* Download French CSV */}
                     {translations.createProspective.Download_French_template[language]}
                  </span>
                   }
                  
                </div>
                }
                  <div className="d-flex gap-3">
                    <button
                      type="submit"
                      className="admin-btn btn btn-primary"
                      // id="add-dealership"
                      disabled={isSubmitting}
                    // data-bs-toggle="modal"
                    // data-bs-target="#modalQuickAdd"
                    >
                      {translations.commonFields.upload[language]}
                    </button>
                    <button
                      id="bulkUploadClose"
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                      // data-bs-toggle={quickAdd ? "modal" : ""}
                      // data-bs-target={quickAdd ? "#modalQuickAdd" : ""}
                      onClick={() => {
                        resetForm();
                        // setValues({
                        //   data: "",
                        //   // private_event_id: "",
                        // });
                        setUploading(false);
                        setUploadProgress(0);
                        setTotalRows(0);
                        setSuccessfulRows(0);
                        setFailedRows(0);
                        setShowStat(false);
                      }}
                    >
                      {translations["commonFields"].closeBtn[language]}
                    </button>
                  </div>
                  {/* <br />
                  <div
                    className="alert alert-danger d-flex align-items-center invisible"
                    id="clientFormAlert"
                    role="alert"
                  >
                    <div id="clientFormAlertText"></div>
                  </div> */}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      {loading && <Loader />}
    </div>
  );
};

export default BulkUpload;
